export default __webpack_public_path__ + "static/media/Home-Improvement.d4bedbf8.jpg";